import { PropsWithChildren } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { HiddenMobile } from '../../../../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { DesktopTopHeaderBarSkeleton } from '../../../../layouts/LayoutWithLeftDesktopNav/DesktopTopHeaderBar/DesktopTopHeaderBarSkeleton';
import { HiddenDesktop } from '../../../../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenDesktop/HiddenDesktop';
import { DesktopLeftNavSkeleton } from '../../../../layouts/LayoutWithLeftDesktopNav/DesktopLeftNav/DesktopLeftNavSkeleton';
import { MobileHeaderSkeleton } from '../../../../layouts/LayoutWithLeftDesktopNav/MobileHeader/MobileHeaderSkeleton';

interface PageSkeletonWrapperProps extends PropsWithChildren {
  showTopMenuSkeleton?: boolean;
  alignChildrenToRight?: boolean;
}

export const PageSkeletonWrapper = ({
  showTopMenuSkeleton = true,
  alignChildrenToRight = false,
  children,
}: PageSkeletonWrapperProps) => {
  return (
    <div
      className={css({
        lg: {
          paddingTop: 'calc(var(--spacing-extra_small_4) + 72px)',
          paddingInlineStart: 'calc(var(--spacing-extra_small_4) + 73px)',
        },
        backgroundColor: {
          base: 'screen_background.primary',
          lg: 'none',
        },
        height: '100vh',
      })}
    >
      <HiddenMobile>
        <DesktopTopHeaderBarSkeleton />
      </HiddenMobile>

      <HiddenMobile>
        <DesktopLeftNavSkeleton />
      </HiddenMobile>

      {showTopMenuSkeleton && (
        <HiddenDesktop>
          <MobileHeaderSkeleton />
        </HiddenDesktop>
      )}

      <div
        className={css({
          width: {
            base: '100%',
            lg: '1440px',
          },
          maxWidth: '100%',
          mx: 'auto',
          height: {
            base: '100%',
            lg: 'calc(100vh - var(--spacing-extra_small_4) - 74px)',
          },
          ...(alignChildrenToRight && {
            display: 'flex',
            justifyContent: 'flex-end',
          }),
        })}
      >
        {children}
      </div>
    </div>
  );
};
